/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import classNames from "classnames";
import moment from "moment";
import "moment/locale/fr";

import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Snackbar from "@material-ui/core/Snackbar";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import MuiAlert from "@material-ui/lab/Alert";

import GetAppIcon from "@material-ui/icons/GetApp";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ComputerIcon from "@material-ui/icons/Computer";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import EuroSymbolIcon from "@material-ui/icons/EuroSymbol";
import BusinessCenterIcon from "@material-ui/icons/BusinessCenter";
import GroupIcon from "@material-ui/icons/Group";
import SchoolIcon from "@material-ui/icons/School";

import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import SectionFooter from "views/footer/PageFooter.js";

import presentationStyle from "assets/jss/material-kit-pro-react/views/echosup/SecretaireMedicaleStyle.js";
import logo_ecosup from "assets/img/ecosup.png";
import imgSecCompta from "assets/img/AdobeStock_1634742965.webp";

const useStyles = makeStyles(presentationStyle);

const FORMATION_ID = 4;
const initialFormState = {
  nom: "",
  prenom: "",
  email: "",
  phone: "",
  acceptTerms: false
};

const prerequisites = [
  {
    icon: EmojiEventsIcon,
    title: "Titre de niveau 3 et expérience significative dans le secteur"
  },
  {
    icon: CalendarTodayIcon,
    title: "Être âgé(e) de 18 ans minimum"
  },
  {
    icon: ComputerIcon,
    title: "Maîtrise des savoirs de base, des outils bureautiques et bonnes capacités rédactionnelles"
  }
];

const objectives = [
  "Assurer les travaux administratifs de secrétariat au quotidien",
  "Assurer les opérations comptables courantes",
  "Préparer les opérations comptables périodiques"
];

const pedagogyItems = [
  "En présentiel sur site ou à distance selon les impératifs",
  "Par des approches magistrales, participatives ou de découverte",
  "En classe entière, par petits groupes ou en individuel"
];

const procedureSteps = [
  "Je m'inscris à une session d'information",
  "Je remplis un dossier de candidature avec les pièces justificatives",
  "Je me rends à la session d'information pour le test de positionnement et l'entretien individuel",
  "Je reçois ma réponse d'admissibilité sous 7 jours par mail"
];

const programmeBlocks = [
  {
    title: "Bloc de compétences 1 (CCP1) – Assurer les travaux administratifs de secrétariat au quotidien",
    bullets: [
      "Enseignements théoriques + ateliers pratiques : bureautique, communication écrite, accueil, organisation du temps, gestion documentaire",
      "Exercices, mises en situation et études de cas",
      "Évaluations formatives régulières"
    ]
  },
  {
    title: "Bloc de compétences 2 (CCP2) – Assurer les opérations comptables au quotidien",
    bullets: [
      "Théorie et pratique : documents commerciaux, saisie comptable, trésorerie, suivi clients/fournisseurs",
      "Utilisation de logiciels comptables ou simulateurs",
      "Travaux dirigés et exercices progressifs, études de cas réels"
    ]
  },
  {
    title: "Bloc de compétences 3 (CCP3) – Préparer les opérations comptables périodiques",
    bullets: [
      "TVA, paie et variables de paie, tableaux de bord, exploitation des données sociales et fiscales",
      "Cas pratiques périodiques, simulations de fin de mois et de fin d'année",
      "Utilisation d'outils numériques et ERP selon disponibilités"
    ]
  }
];

const complementarySkills = [
  "Techniques de recherche d'emploi et communication professionnelle",
  "Culture numérique, sécurité des données, orthographe et rédaction professionnelle",
  "Soft skills : gestion du stress, priorisation, accueil et relation client/fournisseur",
  "Maîtrise des outils bureautiques : Excel, Word, PowerPoint, messagerie…"
];

const evaluationItems = [
  "Mises en situation professionnelles évaluées par un jury de professionnels",
  "Évaluation continue tout au long de la formation",
  "Dossier professionnel à constituer",
  "Entretien final avec le jury"
];

const pathways = [
  "Secrétaire comptable",
  "Secrétaire administratif / polyvalent",
  "Assistant administratif"
];

const professionalContexts = [
  "TPE ou PME",
  "Associations",
  "Cabinets comptables",
  "Structures de services"
];

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function SecretaireComptablePage() {
  const classes = useStyles();
  const [formData, setFormData] = useState(initialFormState);
  const [sessionSelect, setSessionSelect] = useState("");
  const [sessionsOptions, setSessionsOptions] = useState([]);
  const [sessionsData, setSessionsData] = useState([]);
  const [modalDownload, setModalDownload] = useState(false);
  const [modalInscription, setModalInscription] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  moment.locale("fr");

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    fetchSessions();
  }, []);

  const fetchSessions = () => {
    axios
      .get(`${global.API_URL}/session-informations`)
      .then((res) => {
        const filteredSessions = res.data.filter(
          (session) =>
            Array.isArray(session.formations) &&
            session.formations.some((formation) => formation.id === FORMATION_ID)
        );

        console.log(filteredSessions)

        const selectOptions = filteredSessions.map((session) => {
          const date = moment(session.date);
          const text = `${date.format("dddd D MMMM YYYY à HH:mm")}`;
          return { id: session.id, text: text.charAt(0).toUpperCase() + text.slice(1) };
        });

        setSessionsData(filteredSessions);
        setSessionsOptions(selectOptions);
      })
      .catch(() => {
        setSessionsData([]);
        setSessionsOptions([]);
      });
  };

  const resetForm = () => {
    setFormData(initialFormState);
    setErrors({});
    setSessionSelect("");
  };

  const validateForm = (requireSession = false) => {
    const newErrors = {};

    if (!formData.nom.trim()) {
      newErrors.nom = "Le nom est requis";
    }
    if (!formData.prenom.trim()) {
      newErrors.prenom = "Le prénom est requis";
    }
    if (!formData.email.trim()) {
      newErrors.email = "L'email est requis";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email invalide";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Le téléphone est requis";
    }
    if (!formData.acceptTerms) {
      newErrors.acceptTerms = "Vous devez accepter les conditions";
    }
    if (requireSession && !sessionSelect) {
      newErrors.session = "Veuillez sélectionner une session";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDownload = () => {
    if (!validateForm()) {
      return;
    }
    setIsLoading(true);
    const dataForm = new FormData();
    dataForm.append(
      "data",
      JSON.stringify({
        nom: formData.nom,
        prenom: formData.prenom,
        email: formData.email,
        phone: formData.phone,
        acceptTerms: formData.acceptTerms,
        formation: FORMATION_ID
      })
    );

    axios
      .post(`${global.API_URL}/downloads`, dataForm)
      .then(() => {
        window.open(`${global.url_plaquette_comptable}`);
        setSnackbar({ open: true, message: "Documentation téléchargée avec succès!", severity: "success" });
        setModalDownload(false);
        resetForm();
      })
      .catch(() => {
        setSnackbar({ open: true, message: "Erreur lors du téléchargement", severity: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSessionRegistration = () => {
    if (!validateForm(true)) {
      return;
    }
    setIsLoading(true);
    const dataForm = new FormData();
    dataForm.append(
      "data",
      JSON.stringify({
        nom: formData.nom,
        prenom: formData.prenom,
        email: formData.email,
        phone: formData.phone,
        session_information: sessionSelect
      })
    );

    axios
      .post(`${global.API_URL}/rdv-sessions`, dataForm)
      .then(() => {
        setSnackbar({ open: true, message: "Inscription réussie!", severity: "success" });
        setModalInscription(false);
        resetForm();
      })
      .catch(() => {
        setSnackbar({ open: true, message: "Erreur lors de l'inscription", severity: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const hasSessions = sessionsData.length > 0;

  const renderChecklist = (items) =>
    items.map((item) => (
      <div
        key={item}
        style={{ display: "flex", alignItems: "flex-start", marginBottom: "10px" }}
      >
        <CheckCircleIcon style={{ color: "#00acc1", marginRight: "5px", marginTop: "0px" }} />
        <p className={classes.description} style={{ marginBottom: 0 }}>
          {item}
        </p>
      </div>
    ));

  return (
    <div>
      <Helmet>
        <title>Secrétaire Comptable Toulon - Formation en alternance | EcoSup</title>
        <meta name="description" content="Formation Secrétaire Comptable en alternance à Toulon. Titre professionnel niveau 4 (RNCP 37123). 14 à 18 mois, 1 jour de cours par semaine." />
        <link rel="canonical" href="https://www.ecosup-toulon.fr/secretaire-comptable" />
      </Helmet>
      <Header
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 50,
          color: "white"
        }}
      />
      <Parallax
        image={require("assets/img/AdobeStock_576823402.webp")}
        className={classes.parallax}
        filter="dark"
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <GridContainer justifyContent="center" alignItems="center">
                  <GridItem xs={12} sm={4} md={4}>
                    <img
                      src={logo_ecosup}
                      alt="..."
                      className={classes.imgRounded + " " + classes.imgFluid}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={8} md={8}>
                    <h1 className={classes.title}>Secrétaire comptable</h1>
                  </GridItem>
                </GridContainer>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.section}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={8} md={8}>
                <h3 className={classes.title2}>Prérequis</h3>
                <div className={classes.features}>
                  <GridContainer>
                    {prerequisites.map((item, index) => (
                      <GridItem xs={12} sm={4} md={4} key={index}>
                        <InfoArea
                          vertical
                          icon={item.icon}
                          title={item.title}
                          description=""
                          iconColor="comptable"
                        />
                      </GridItem>
                    ))}
                  </GridContainer>
                </div>
                <h5 className={classes.description}>
                  Pour les équivalences, passerelles et suites de parcours se rapprocher de Camille Dupain au {global.phone_direction}
                </h5>

                <h3 className={classes.cardTitle}>Objectifs</h3>
                {renderChecklist(objectives)}

                <h3 className={classes.cardTitle}>Méthodes pédagogiques</h3>
                <p className={classes.description}>La formation est dispensée :</p>
                {renderChecklist(pedagogyItems)}

                <h3 className={classes.cardTitle}>Procédure de candidature</h3>
                {procedureSteps.map((step, index) => (
                  <h5 className={classes.description} key={step}>
                    <b>Étape {index + 1} :</b> {step}
                  </h5>
                ))}

                <h3 className={classes.cardTitle}>Programme de formation – 3 CCP</h3>
                {programmeBlocks.map((bloc) => (
                  <div key={bloc.title} style={{ marginBottom: "25px" }}>
                      <h3 className={classes.cardTitle}>{bloc.title}</h3>
                      {renderChecklist(bloc.bullets)}
                  </div>
                ))}

                    <h3 className={classes.cardTitle}>
                      Compétences transverses et supports complémentaires
                    </h3>
                    {renderChecklist(complementarySkills)}

                    <h3 className={classes.cardTitle}>
                      Modalités d'évaluation des compétences / Certification
                    </h3>
                    {renderChecklist(evaluationItems)}

                <h3 className={classes.cardTitle}>Indicateurs de résultats</h3>
                <h5 className={classes.description}>
                  Taux de Réussite : chiffres à venir
                </h5>
                <h5 className={classes.description}>
                  Taux d'Insertion à 6 mois : chiffres à venir
                </h5>
                <h5 className={classes.description}>
                  Taux d'Insertion dans les métiers visés : chiffres à venir
                </h5>
                <h5 className={classes.description}>
                  Taux d’interruption en cours de formation : chiffres à venir
                </h5>
                <h5 className={classes.description}>
                  Taux Global d'Accomplissement : chiffres à venir
                </h5>
                <h5 className={classes.description}>
                  Taux d'abandons : chiffres à venir
                </h5>
                <h5 className={classes.description}>
                  Taux de satisfaction global : chiffres à venir
                </h5>
                <h5 className={classes.description}>
                  Taux de poursuite d’études : chiffres à venir
                </h5>
                <h5 className={classes.description}>
                  Nos chiffres ne sont pas inscrits sur Insert Jeunes et nous ne communiquons pas sur la valeur ajoutée seul les établissements publics et les établissements d’enseignements privés sous contrats sont concernés. 
                </h5>

                {/* <h3 className={classes.cardTitle}>Poursuite d'études et passerelles</h3>
                <h5 className={classes.description}>
                  Pour les équivalences, passerelles et suites de parcours, contactez Camille Dupain au {global.phone_direction}.
                </h5>
                {renderChecklist(pathways)} */}


              </GridItem>

              <GridItem xs={12} sm={4} md={4}>

                <Card
                backgroundComptable
                style={{ backgroundImage: `url(${imgSecCompta})` }}
              >
                <CardBody background>
                  <h3 className={classes.cardTitleWhite}>
                    Vous souhaitez devenir secrétaire comptable ?
                  </h3>
                  <br/>
                  <h3 className={classes.cardTitleWhite}>
                    Rendez vous à notre prochaine session d'information
                  </h3>
                  <br/>
                  <br/>
                  <p className={classes.cardDescriptionWhite}>
                    <b>Impasse du Docteur Charles Barnier</b>
                  </p>
                  <p className={classes.cardDescriptionWhite}>
                    <b>83000 Toulon</b>
                  </p>
                  <br/>
                  <br/>
                  {hasSessions ?
                  <Button color="white" round onClick={() => {setModalInscription(true)}}>
                    Je m'inscris
                  </Button> : <h6>pas de session prévue pour l'instant</h6>}
                  <br/>
                  <br/>
                </CardBody>
              </Card>

                <div className={classes.buttonCenter}>
                  <Button color="comptable" round onClick={() => { resetForm(); setModalDownload(true); }}>
                    <GetAppIcon style={{ marginRight: "8px" }} /> Télécharger la documentation
                  </Button>
                </div>


                    <h3 className={classes.cardTitle}>
                      <AccessTimeIcon style={{ verticalAlign: "middle", marginRight: "8px" }} /> Dispositif de formation
                    </h3>
                    <h5 className={classes.description}>Formation de 14 à 18 mois en alternance, 1 jour de cours par semaine.</h5>
                    <h5 className={classes.description}>Rentrées permanentes en présentiel.</h5>


                    <h3 className={classes.cardTitle}>
                      <GroupIcon style={{ verticalAlign: "middle", marginRight: "8px" }} /> Equipe pédagogique & admissions
                    </h3>
                    <h5 className={classes.description}>Directrice et référente handicap : Camille DUPAIN</h5>
                    <h5 className={classes.description}>Relations entreprises : Elise THIEBAUX et Juliette CREPON</h5>
                    <h5 className={classes.description}>Pédagogie : Marine GREBOT</h5>
                    <h5 className={classes.description}>Admissions & Accueil : Sarah ZAGARRIO</h5>

                    <h3 className={classes.cardTitle}>
                      <SchoolIcon style={{ verticalAlign: "middle", marginRight: "8px" }} /> Type de diplôme
                    </h3>
                    <h5 className={classes.description}>
                      Certification professionnelle de niveau 4 (RNCP 37123) – Titre Professionnel de Secrétaire comptable délivré par le Ministère du Travail, du Plein emploi et de l'Insertion (05/12/2022).
                    </h5>
 

                    <h3 className={classes.cardTitle}>
                      <EuroSymbolIcon style={{ verticalAlign: "middle", marginRight: "8px" }} /> Tarif
                    </h3>
                    <h5 className={classes.description}>
                      Formation en alternance : les coûts pédagogiques sont pris en charge par les OPCO dans le cadre de l'alternance.
                    </h5>

                    <h3 className={classes.cardTitle}>
                      <BusinessCenterIcon style={{ verticalAlign: "middle", marginRight: "8px" }} /> Débouchés professionnels
                    </h3>
                    <h5 className={classes.description}>
                      Secrétaire comptable • Secrétaire administratif(ve) / polyvalent(e) • Assistant(e) administratif(ve) • Secrétaire facturier
                    </h5>
              </GridItem>
            </GridContainer>
          </div>
        </div>
        <Dialog
          classes={{
            root: classes.center,
            paper: classes.modal
          }}
          open={modalDownload}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setModalDownload(false)}
          aria-labelledby="modal-download-title"
          aria-describedby="modal-download-description"
          maxWidth="md"
        >
          <DialogTitle id="modal-download-title" disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Téléchargez la documentation</h4>
            <p className={classes.description}>Veuillez remplir le formulaire pour accéder au téléchargement</p>
          </DialogTitle>
          <DialogContent id="modal-download-description" className={classes.modalBody}>
            <GridContainer>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Nom"
                  id="download-nom"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: formData.nom,
                    onChange: (e) => {
                      setFormData({ ...formData, nom: e.target.value });
                      if (errors.nom) setErrors({ ...errors, nom: "" });
                    },
                    required: true
                  }}
                />
                <p style={{ color: "red", fontSize: "12px" }}>{errors.nom}</p>
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Prénom"
                  id="download-prenom"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: formData.prenom,
                    onChange: (e) => {
                      setFormData({ ...formData, prenom: e.target.value });
                      if (errors.prenom) setErrors({ ...errors, prenom: "" });
                    },
                    required: true
                  }}
                />
                <p style={{ color: "red", fontSize: "12px" }}>{errors.prenom}</p>
              </GridItem>
            </GridContainer>
            <CustomInput
              labelText="Téléphone"
              id="download-phone"
              formControlProps={{ fullWidth: true }}
              inputProps={{
                value: formData.phone,
                onChange: (e) => {
                  setFormData({ ...formData, phone: e.target.value });
                  if (errors.phone) setErrors({ ...errors, phone: "" });
                },
                required: true
              }}
            />
            <p style={{ color: "red", fontSize: "12px" }}>{errors.phone}</p>
            <CustomInput
              labelText="Email"
              id="download-email"
              formControlProps={{ fullWidth: true }}
              inputProps={{
                value: formData.email,
                onChange: (e) => {
                  setFormData({ ...formData, email: e.target.value });
                  if (errors.email) setErrors({ ...errors, email: "" });
                },
                required: true
              }}
            />
            <p style={{ color: "red", fontSize: "12px" }}>{errors.email}</p>
            <FormControlLabel
              control={
                <Checkbox
                  color="default"
                  checked={formData.acceptTerms}
                  onChange={(e) => {
                    setFormData({ ...formData, acceptTerms: e.target.checked });
                    if (errors.acceptTerms) setErrors({ ...errors, acceptTerms: "" });
                  }}
                />
              }
              label="J'accepte l'enregistrement de mes informations dans la base de données de l'école."
            />
            <p style={{ color: "red", fontSize: "12px" }}>{errors.acceptTerms}</p>
            <p className={classes.rgpd}>
              Les informations recueillies sur ce formulaire sont enregistrées dans un fichier informatisé par EcoSup Toulon pour vous tenir informés d'informations importantes relatives à votre admissibilité. Elles sont conservées pendant 1 an et sont destinées au service des admissions. Conformément à la loi « informatique et libertés », vous pouvez exercer votre droit d'accès aux données vous concernant et les faire rectifier en contactant : contact@ecosup-toulon.fr
            </p>
          </DialogContent>
          <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
            <Button onClick={handleDownload} color="comptable" round>
              {isLoading ? "Veuillez patienter ..." : "Téléchargement"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          classes={{
            root: classes.center,
            paper: classes.modal
          }}
          open={modalInscription}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setModalInscription(false)}
          aria-labelledby="modal-inscription-title"
          aria-describedby="modal-inscription-description"
          maxWidth="md"
        >
          <DialogTitle id="modal-inscription-title" disableTypography className={classes.modalHeader}>
            <h4 className={classes.modalTitle}>Réunion d'informations à Toulon</h4>
            <p className={classes.features}>Lieu de la réunion : <b>Ecosup-Toulon</b></p>
            <p className={classes.features}>177 Boulevard Charles Barnier, 83000 Toulon</p>
            <p className={classes.features}>(accès depuis l'impasse Barnier)</p>
          </DialogTitle>
          <DialogContent id="modal-inscription-description" className={classes.modalBody}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel htmlFor="session-select" className={classes.selectLabel}>
                    Session
                  </InputLabel>
                  <Select
                    MenuProps={{ className: classes.selectMenu }}
                    classes={{ select: classes.select }}
                    value={sessionSelect}
                    onChange={(e) => {
                      setSessionSelect(e.target.value);
                      if (errors.session) setErrors({ ...errors, session: "" });
                    }}
                    inputProps={{
                      name: "sessionSelect",
                      id: "session-select"
                    }}
                  >
                    {sessionsOptions.map((session) => (
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected
                        }}
                        value={session.id}
                        key={session.id}
                      >
                        {session.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <p style={{ color: "red", fontSize: "12px" }}>{errors.session}</p>
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Nom"
                  id="inscription-nom"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: formData.nom,
                    onChange: (e) => {
                      setFormData({ ...formData, nom: e.target.value });
                      if (errors.nom) setErrors({ ...errors, nom: "" });
                    },
                    required: true
                  }}
                />
                <p style={{ color: "red", fontSize: "12px" }}>{errors.nom}</p>
              </GridItem>
              <GridItem xs={12} sm={6} md={6}>
                <CustomInput
                  labelText="Prénom"
                  id="inscription-prenom"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    value: formData.prenom,
                    onChange: (e) => {
                      setFormData({ ...formData, prenom: e.target.value });
                      if (errors.prenom) setErrors({ ...errors, prenom: "" });
                    },
                    required: true
                  }}
                />
                <p style={{ color: "red", fontSize: "12px" }}>{errors.prenom}</p>
              </GridItem>
            </GridContainer>
            <CustomInput
              labelText="Téléphone"
              id="inscription-phone"
              formControlProps={{ fullWidth: true }}
              inputProps={{
                value: formData.phone,
                onChange: (e) => {
                  setFormData({ ...formData, phone: e.target.value });
                  if (errors.phone) setErrors({ ...errors, phone: "" });
                },
                required: true
              }}
            />
            <p style={{ color: "red", fontSize: "12px" }}>{errors.phone}</p>
            <CustomInput
              labelText="Email"
              id="inscription-email"
              formControlProps={{ fullWidth: true }}
              inputProps={{
                value: formData.email,
                onChange: (e) => {
                  setFormData({ ...formData, email: e.target.value });
                  if (errors.email) setErrors({ ...errors, email: "" });
                },
                required: true
              }}
            />
            <p style={{ color: "red", fontSize: "12px" }}>{errors.email}</p>
            <FormControlLabel
              control={
                <Checkbox
                  color="default"
                  checked={formData.acceptTerms}
                  onChange={(e) => {
                    setFormData({ ...formData, acceptTerms: e.target.checked });
                    if (errors.acceptTerms) setErrors({ ...errors, acceptTerms: "" });
                  }}
                />
              }
              label="J'accepte l'enregistrement de mes informations pour l'organisation des sessions d'information"
            />
            <p style={{ color: "red", fontSize: "12px" }}>{errors.acceptTerms}</p>
          </DialogContent>
          <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
            <Button onClick={handleSessionRegistration} color="vidal" round>
              {isLoading ? "Veuillez patienter ..." : "Inscription"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <SectionFooter date={"11 Février 2026"} />
    </div>
  );
}
